// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/straight_img/straight_bg_hero.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/straight_img/straight_bg_hero_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/straight_img/convert_howbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/straight_img/convert_howbg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../public/images/straight_img/straight-ctabg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../public/images/straight_img/straight-ctabg_light.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.straight-page-wrapper {
  background-color: #0b0e14;
  color: #f1f5f9;
  overflow-x: hidden;
  position: relative;
  min-height: 100vh;
}

.straight-container {
  max-width: 1480px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

.straight-text-gold {
  color: #D1AA67;
}

/* ==========================================================================
   2. HERO SECTION
   ========================================================================== */
.straight-hero-section {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 1060px;
  text-align: center;
  overflow: hidden;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center top;
  background-repeat: no-repeat;
}

body.light_theme .straight-hero-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.straight-hero-particles-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.straight-hero-content {
  position: relative;
  z-index: 2;
  max-width: 1220px;
  margin: 0 auto;
  padding-top: 230px;
}

.straight-hero-title {
  font-size: 80px;
  font-weight: 600;
  line-height: 1.18;
  color: #ffffff;
  margin-bottom: 22px;
}

body.light_theme .straight-hero-title {
  color: #1f1f1f;
}

.straight-hero-subtitle {
  font-size: 28px;
  line-height: 1.6;
  color: #9CA3AF;
  max-width: 870px;
  margin: 0 auto 36px;
  font-weight: 400;
}

.straight-hero-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.straight-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #D1AA67;
  color: #fff;
  font-size: 22px;
  font-weight: 500;
  padding: 14px 36px;
  min-height: 70px;
  border-radius: 9999px;
  text-decoration: none;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(230, 167, 58, 0.35);
  transition: all 0.3s ease;
}

.straight-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 26px rgba(230, 167, 58, 0.5);
  color: #0b0e14;
}

.straight-btn-primary i {
  transition: transform 0.2s ease;
}

.straight-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgb(82 82 82 / 85%);
  color: #E5E7EB;
  font-size: 22px;
  font-weight: 500;
  padding: 14px 36px;
  min-height: 70px;
  border-radius: 9999px;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.14);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  cursor: pointer;
  transition: all 0.3s ease;
}

.straight-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  transform: translateY(-2px);
}

/* ==========================================================================
   3. FOUR STEPS SECTION
   ========================================================================== */
.straight-steps-section {
  position: relative;
  padding: 100px 0 110px;
  background-color: #1E2025;
}

body.light_theme .straight-steps-section {
  background-color: #ffffff;
}

body.light_theme .straight-steps-title {
  color: #141414;
}

body.light_theme .straight-step-card {
  background: rgb(0 0 0 / 10%);
  border: 1px solid rgb(0 0 0 / 7%);
  box-shadow: 0px 0px 0px 6px rgb(0 0 0 / 15%);
}

.straight-steps-section-header {
  text-align: center;
  margin-bottom: 60px;
}

.straight-steps-title {
  font-size: 60px;
  font-weight: 500;
  color: #ffffff;
}

.straight-steps-grid-container {
  position: relative;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 40px 0px 24px;
}

/* Horizontal Blue Dotted Connector */
.straight-steps-horizontal-track {
  position: absolute;
  top: 50%;
  left: 40px;
  right: 40px;
  transform: translateY(-50%);
  height: 2px;
  pointer-events: none;
  z-index: 1;
}

.steps_afterlft.effectusdt {
  left: -30px;
}

.steps_afterrgt.effectusdt {
  right: -30px;
}

.effectusdt {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 250px;
  opacity: 0.5;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
}

.straight-golden-matrix-canvas {
  width: 100%;
  height: 100%;
  display: block;
}

.straight-steps-blue-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  border-top: 2px dashed #0284c7;
  opacity: 0.85;
}

.straight-steps-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 28px;
  position: relative;
  z-index: 2;
  justify-items: center;
}

.straight-step-card-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 320px;
  height: 450px;
}

/* Outer Orbit SVG Track matching exact Figma layout */
.straight-step-orbit-figma-svg {
  position: absolute;
  top: -65px;
  left: 50%;
  transform: translateX(-50%);
  width: 340px;
  height: 580px;
  pointer-events: none;
  z-index: 1;
  overflow: visible;
}

.straight-step-base-arc {
  stroke: rgba(209, 170, 103, 0.35);
  transition: stroke 0.3s ease;
}

body.light_theme .straight-step-base-arc {
  stroke: rgba(209, 170, 103, 0.5);
}

.straight-step-top-arc {
  stroke: #D1AA67;
  stroke-dasharray: 160 440;
  animation: flowFigmaTopArc 5.5s linear infinite;
}

.straight-step-bottom-arc {
  stroke: #D1AA67;
  stroke-dasharray: 160 440;
  animation: flowFigmaBottomArc 5.5s linear infinite;
}

body.light_theme .straight-step-top-arc,
body.light_theme .straight-step-bottom-arc {
  stroke: #D1AA67;
}

@keyframes flowFigmaTopArc {
  0% {
    stroke-dashoffset: 0;
  }

  100% {
    stroke-dashoffset: -600;
  }
}

@keyframes flowFigmaBottomArc {
  0% {
    stroke-dashoffset: 0;
  }

  100% {
    stroke-dashoffset: 600;
  }
}

.straight-step-node-bg {
  fill: #1E2025;
  transition: fill 0.3s ease;
}

body.light_theme .straight-step-node-bg {
  fill: #ffffff;
}

.straight-step-node-dot {
  fill: #D1AA67;
}

.straight-step-node-glow {
  transform-origin: center center;
  animation: pulseNodeGlow 4s ease-in-out infinite;
}

@keyframes pulseNodeGlow {

  0%,
  100% {
    filter: drop-shadow(0 0 3px rgba(209, 170, 103, 0.6));
  }

  50% {
    filter: drop-shadow(0 0 8px rgba(209, 170, 103, 0.95));
  }
}

body.light_theme .straight-step-node-glow {
  animation: pulseNodeGlowLight 4s ease-in-out infinite;
}

@keyframes pulseNodeGlowLight {

  0%,
  100% {
    filter: drop-shadow(0 0 3px rgba(209, 170, 103, 0.45));
  }

  50% {
    filter: drop-shadow(0 0 7px rgba(209, 170, 103, 0.8));
  }
}

.straight-step-card {
  position: relative;
  z-index: 2;
  background: rgb(255 255 255 / 10%);
  border: 1px solid rgb(255 255 255 / 22%);
  border-radius: 100px;
  padding: 36px 26px 40px;
  box-shadow: 0px 0px 0px 6px rgb(255 255 255 / 20%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: all 0.35s ease;
  min-height: 450px;
  width: 210px;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
}

.straight-step-card:hover {
  transform: translateY(-6px);
  border-color: rgba(245, 184, 66, 0.3);
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.45), 0 0 24px rgba(245, 184, 66, 0.1);
}

.straight-step-icon-box {
  width: 122px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

.straight-step-card:hover .straight-step-icon-box {
  background: rgba(245, 184, 66, 0.12);
  border-color: rgba(245, 184, 66, 0.4);
  transform: scale(1.05);
}

.straight-step-icon {
  width: 100%;
  object-fit: contain;
}

.straight-step-card-title {
  font-size: 24px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 10px;
  line-height: 1.35;
  /* min-height: 44px; */
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .straight-step-card-title {
  color: #212121;
}

.straight-step-card-desc {
  font-size: 13px;
  color: #94A3B8;
  line-height: 1.55;
  margin: 0;
}

body.light_theme .straight-step-card-desc {
  color: #5f5f5f;
}

body.light_theme .straight-features-section {
  background-color: #f5f5f5;
}

body.light_theme .straight-features-title {
  color: #202020;
}

body.light_theme .straight-feature-card {
  background: rgb(39 40 46 / 6%);
  border: 1px solid rgb(0 0 0 / 6%);
}

body.light_theme .straight-feature-card-title {
  color: #232323;
}

body.light_theme .straight-feature-card-desc {
  color: #393939;
}

body.light_theme .straight-feature-card-img-wrapper {
  opacity: 0.4;
}

/* Connecting arrows / curves between steps */
.straight-steps-connectors {
  position: absolute;
  top: 70px;
  left: 0;
  width: 100%;
  height: 200px;
  pointer-events: none;
  z-index: 1;
}

/* ==========================================================================
   4. THE SIMPLE WAY SECTION (FEATURES GRID)
   ========================================================================== */
.straight-features-section {
  position: relative;
  padding: 100px 0 110px;
  background-color: #171A20;
  overflow: hidden;
}

.straight-features-header {
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  z-index: 2;
}

.straight-features-title {
  font-size: 60px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.25;
}

.straight-features-grid-top {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 24px;
  position: relative;
  z-index: 2;
}

.straight-features-grid-mid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-bottom: 24px;
  position: relative;
  z-index: 2;
}

.straight-features-grid-bottom {
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  z-index: 2;
}

.straight-feature-card {
  background: #27282E;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 24px;
  padding: 32px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  transition: all 0.35s ease;
}

.straight-feature-card:hover {
  transform: translateY(-4px);
  border-color: rgba(245, 184, 66, 0.25);
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.4);
}

.straight-feature-card-content {
  position: relative;
  z-index: 2;
  margin-bottom: 0px;
}

.straight-feature-card-title {
  font-size: 24px;
  font-weight: 600;
  color: #ededed;
  margin-bottom: 12px;
  line-height: 1.3;
}

.straight-feature-card-desc {
  font-size: 16px;
  color: #AEAEAE;
  line-height: 1.6;
  margin: 0;
}

.straight-feature-card-img-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  filter: brightness(0.5);
  opacity: 0.6;
}

.straight-features-grid-mid .straight-feature-card {
  flex-direction: row;
  gap: 48px;
}

.straight-features-grid-mid .straight-feature-card-img-wrapper {
  width: 100%;
  min-width: 255px;
}

.straight-feature-card-img {
  max-width: 100%;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.straight-feature-card:hover .straight-feature-card-img {
  transform: scale(1.04);
}

/* Wide bottom card layout */
.straight-feature-card-wide {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 36px 40px;
  gap: 40px;
}

.straight-feature-card-wide .straight-feature-card-content {
  max-width: 780px;
  margin-bottom: 0;
}

.straight-feature-card-wide .straight-feature-card-img-wrapper {
  max-width: 330px;
  margin-top: 0;
  margin-right: 100px;
  min-height: auto;
}

.straight-feature-card-wide .straight-feature-card-img {
  max-height: 100%;
}

.straight-feature-card:hover .straight-feature-card-img-wrapper {
  filter: brightness(1);
  opacity: 1;
}

/* ==========================================================================
   5. COSTS AND DURATION SECTION (TABLE)
   ========================================================================== */
.straight-costs-section {
  position: relative;
  padding: 100px 0 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center top;
  background-repeat: no-repeat;
}

body.light_theme .straight-costs-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.straight-costs-header {
  text-align: center;
  margin-bottom: 50px;
}

.straight-costs-title {
  font-size: 60px;
  font-weight: 500;
  color: #ffffff;
  line-height: 1.25;
}

body.light_theme .straight-costs-title {
  color: #202020;
}

.straight-costs-table-card {
  max-width: 100%;
  margin: 0 auto;
  background: linear-gradient(180deg, rgba(50, 41, 26, 0.9) 0%, rgba(23, 26, 32, 0.95) 78%);
  border: 1px solid rgba(209, 170, 103, 0.2);
  border-radius: 32px;
  padding: 36px 40px 42px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.4);
}

body.light_theme .straight-costs-table-card {
  background: linear-gradient(180deg, rgba(50, 41, 26, 0.05) 0%, rgba(23, 26, 32, 0.10) 78%);
  border: 1px solid rgba(209, 170, 103, 0.2);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  box-shadow: 0 24px 60px rgb(0 0 0 / 15%);
}

.straight-costs-table-header-row {
  display: grid;
  grid-template-columns: 2.2fr 1.6fr 2.4fr;
  padding: 0 32px 18px;
  align-items: center;
}

.straight-costs-th {
  font-size: 20px;
  font-weight: 500;
  color: #CBD5E1;
}

body.light_theme .straight-costs-th {
  color: #242424;
}

body.light_theme .straight-costs-row-card {
  background: rgb(0 0 0 / 5%);
  border: 1px solid rgb(0 0 0 / 6%);
}

body.light_theme .straight-costs-type-title {
  color: #000;
}

body.light_theme .straight-costs-type-sub {
  color: #232323;
}

body.light_theme .straight-costs-speed-main {
  color: #232323;
}

body.light_theme .straight-costs-speed-sub {
  color: #4e4e4e;
}

body.light_theme .straight-badge-sub {
  color: #2f2f2f;
}

.straight-costs-th-type {
  text-align: left;
}

.straight-costs-th-cost {
  text-align: center;
}

.straight-costs-th-speed {
  text-align: left;
}

.straight-costs-rows-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.straight-costs-row-card {
  display: grid;
  grid-template-columns: 2.2fr 1.6fr 2.4fr;
  align-items: center;
  background: rgb(255 255 255 / 10%);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 20px;
  padding: 18px 36px;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.straight-costs-row-card:hover {
  background: #2a2e36;
  border-color: rgba(209, 170, 103, 0.22);
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);
}

.straight-costs-col-type {
  display: flex;
  flex-direction: column;
}

.straight-costs-type-title {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
}

.straight-costs-type-sub {
  font-size: 16px;
  color: #94A3B8;
  margin-top: 4px;
}

.straight-costs-col-cost {
  display: flex;
  justify-content: center;
  align-items: center;
}

.straight-costs-col-speed {
  font-size: 18px;
  line-height: 1.45;
  font-weight: 300;
}

.straight-costs-speed-main {
  color: #e2e8f0;
  font-weight: 500;
}

.straight-costs-speed-sub {
  color: #7b8494;
  font-weight: 400;
}

/* Badges */
.straight-badge {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 13px 48px;
  border-radius: 9999px;
  text-align: center;
  min-width: 170px;
  transition: all 0.25s ease;
}

.straight-badge-text {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
}

.straight-badge-sub {
  font-size: 14px;
  color: #94A3B8;
  margin-top: 2px;
  line-height: 1.2;
}

.straight-badge-green {
  background: rgb(0 77 64 / 25%);
  color: #00E5B3;
  border: 1.5px solid rgb(0 229 179 / 30%);
}

.straight-badge-gold {
  background: rgb(69 39 2 / 25%);
  color: #FBBF24;
  border: 1.5px solid rgb(245 158 11 / 40%);
}

.straight-badge-blue {
  background: rgb(12 53 77 / 30%);
  color: #38BDF8;
  border: 1.5px solid rgb(2 132 199 / 40%);
}

.straight-badge-purple {
  background: rgb(54 19 74 / 30%);
  color: #D8B4FE;
  border: 1.5px solid rgb(168 85 247 / 40%);
  padding: 9px 26px;
}

/* ==========================================================================
   6. FAQ SECTION (ACCORDION)
   ========================================================================== */
.straight-faq-section {
  position: relative;
  padding: 110px 0 50px;
  background-color: #171A20;
  margin-top: -2px;
}

body.light_theme .straight-faq-section {
  background-color: #ffffff;
}

body.light_theme .straight-faq-title {
  color: #202020;
}

body.light_theme .straight-faq-item {
  background: rgb(0 0 0 / 4%);
}

body.light_theme .straight-faq-question-btn {
  color: #212121;
}

body.light_theme .straight-faq-icon-wrapper {
  border: 1px solid rgb(0 0 0);
}

body.light_theme .straight-faq-answer {
  color: #535353;
  border-top: 1px solid rgb(0 0 0 / 5%);
}

body.light_theme .straight-cta-section {
  background-color: #ffffff;
}

.straight-faq-header {
  margin-bottom: 36px;
}

.straight-faq-title {
  font-size: 52px;
  font-weight: 600;
  color: #ffffff;
}

.straight-faq-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 0 auto;
}

.straight-faq-item {
  background: rgb(255 255 255 / 4%);
  border-radius: 18px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.straight-faq-item:hover {
  border-color: rgba(255, 255, 255, 0.15);
}

/* .straight-faq-item.active {
  border-color: rgba(245, 184, 66, 0.3);
  background: rgba(22, 27, 38, 0.9);
} */

.straight-faq-question-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  background: none;
  border: none;
  color: #ffffff;
  font-size: 22px;
  font-weight: 400;
  text-align: left;
  cursor: pointer;
  gap: 16px;
  transition: color 0.2s ease;
}

.straight-faq-icon-wrapper {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.straight-faq-item.active .straight-faq-icon-wrapper {
  background: rgb(209 170 103 / 20%);
  border-color: #d1aa67;
  color: #d1aa67;
  transform: rotate(45deg);
}

.straight-faq-answer {
  padding: 0 24px 22px;
  color: #94a3b8;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
  padding-top: 16px;
}

.straight-faq-answer p {
  font-size: 16px;
  line-height: 1.65;
}

/* ==========================================================================
   7. CTA BANNER SECTION
   ========================================================================== */
.straight-cta-section {
  position: relative;
  padding: 50px 0 80px;
  background-color: #171A20;
}

.straight-cta-banner-card {
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  border: 1px solid rgb(119 119 119 / 25%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center top;
  background-repeat: no-repeat;
  border-radius: 22px;
  padding: 56px 36px 48px;
  text-align: center;
  overflow: hidden;
}

body.light_theme .straight-cta-banner-card {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

body.light_theme .straight-cta-title {
  color: #171717;
}

body.light_theme .straight-cta-subtitle {
  color: #424242;
}

body.light_theme .straight-cta-disclaimer {
  color: #434343;
}

.straight-cta-title {
  font-size: 60px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 14px;
}

.straight-cta-subtitle {
  font-size: 24px;
  color: #9CA3AF;
  margin: 0px auto 30px;
  max-width: 800px;
  line-height: 1.5;
}

.straight-cta-section .straight-btn-primary {
  font-size: 21px;
  font-weight: 500;
  padding: 17px 36px;
  width: 370px;
  color: #000;
  max-width: 100%;
  border-radius: 22px;
  border: 4px solid rgb(255 255 255 / 10%);
  box-shadow: none;
}

.straight-cta-btn {
  margin-bottom: 24px;
}

.straight-cta-disclaimer {
  font-size: 24px;
  color: #9CA3AF;
  padding-top: 20px;
  margin: 0;
  line-height: 1.5;
}

/* ==========================================================================
   8. RESPONSIVE MEDIA QUERIES
   ========================================================================== */

@media (max-width: 1440px) {

  .straight-hero-title {
    font-size: 60px;
  }

  .straight-hero-subtitle {
    font-size: 24px;
  }

  .straight-steps-title {
    font-size: 48px;
  }

  .straight-features-title {
    font-size: 48px;
  }

  .straight-costs-title {
    font-size: 48px;
  }

  .straight-cta-title {
    font-size: 48px
  }

}

@media (max-width: 1376px) {

  .straight-hero-section {
    min-height: 650px;
    background-size: cover;
  }

  .straight-hero-content {
    padding-top: 50px;
  }

  .straight-hero-title {
    font-size: 48px;
  }

  .straight-hero-subtitle {
    font-size: 20px;
  }

  .straight-btn-secondary {
    font-size: 16px;
    padding: 11px 36px;
    min-height: 56px;
  }

  .straight-btn-primary {
    font-size: 16px;
    padding: 11px 36px;
    min-height: 56px;
  }

  .straight-container {
    max-width: 95%;
  }

  .straight-steps-title {
    font-size: 38px;
  }

  .straight-step-card-title {
    font-size: 20px;
  }

  .straight-features-title {
    font-size: 38px;
  }

  .straight-costs-title {
    font-size: 38px;
  }

  .straight-faq-title {
    font-size: 42px;
  }

  .straight-cta-title {
    font-size: 38px
  }

  .straight-cta-subtitle {
    font-size: 18px;
  }

  .straight-cta-disclaimer {
    font-size: 18px;
  }

  .straight-cta-section .straight-btn-primary {
    font-size: 18px;
    padding: 12px 36px;
  }

}


@media (max-width: 1200px) {


  .straight-steps-grid {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 112px;
  }

  .straight-features-grid-top {
    grid-template-columns: repeat(2, 1fr);
  }

  .straight-features-grid-mid {
    grid-template-columns: 1fr;
  }

  .straight-feature-card-wide {
    flex-direction: column;
    text-align: left;
    gap: 24px;
  }

  .straight-feature-card-wide .straight-feature-card-img-wrapper {
    max-width: 100%;
  }
}

@media (max-width:991px) {

  .straight-hero-section {
    min-height: 400px;
  }

  .straight-steps-section {
    padding: 40px 0 50px;
  }

  .straight-features-section {
    padding: 40px 0 50px;
  }

  .straight-features-header {
    margin-bottom: 30px;
  }

  .straight-costs-section {
    padding: 40px 0 50px;
  }

  .straight-badge {
    padding: 11px 32px;
    min-width: 100px;
  }

  .straight-badge-text {
    font-size: 15px;
  }

  .straight-costs-col-speed {
    font-size: 15px;
  }

  .straight-costs-row-card {
    padding: 16px 26px;
  }

  .straight-faq-section {
    padding: 40px 0 50px;
  }

  .straight-faq-title {
    font-size: 32px;
  }

  .straight-faq-question-btn {
    padding: 20px;
    font-size: 18px;
  }

  .straight-hero-title {
    font-size: 34px;
  }

  .straight-steps-title,
  .straight-features-title,
  .straight-costs-title,
  .straight-cta-title {
    font-size: 28px;
  }

  .straight-steps-grid {
    grid-template-columns: 1fr;
  }

  .straight-features-grid-top {
    grid-template-columns: 1fr;
  }

  .straight-costs-table-card {
    padding: 16px;
    overflow-x: auto;
  }

  .straight-costs-table thead th,
  .straight-costs-table tbody td {
    padding: 14px 10px;
  }

  .straight-cta-banner-card {
    padding: 36px 20px 32px;
  }

  .straight-costs-row-card {
    gap: 7px;
  }

  .straight-hero-subtitle {
    font-size: 18px;
  }
}

@media (max-width:767px) {

  .straight-hero-title {
    font-size: 24px;
    margin-bottom: 10px;
  }

  .straight-hero-subtitle {
    font-size: 15px;
    margin: 0 auto 18px;
  }

  .straight-btn-secondary {
    font-size: 13px;
    padding: 8px 20px;
    min-height: 38px;
  }

  .straight-btn-primary {
    font-size: 13px;
    padding: 8px 20px;
    min-height: 38px;
  }

  .straight-hero-content {
    padding-top: 0px;
  }

  .straight-hero-section {
    min-height: 100%;
    padding: 40px 0px;
  }

  .straight-steps-title,
  .straight-features-title,
  .straight-costs-title,
  .straight-cta-title {
    font-size: 22px;
  }

  .effectusdt {
    display: none;
  }

  .straight-steps-section-header {
    margin-bottom: 28px;
  }

  .straight-steps-section {
    padding: 35px 0 40px;
  }

  .straight-step-icon-box {
    width: 70px;
  }

  .straight-step-card-title {
    font-size: 18px;
  }

  .straight-features-section {
    padding: 35px 0 40px;
  }

  .straight-feature-card {
    padding: 24px;
  }

  .straight-features-header {
    margin-bottom: 20px;
  }

  .straight-feature-card-title {
    font-size: 18px;
  }

  .straight-feature-card-desc {
    font-size: 14px;
  }

  .straight-feature-card-img-wrapper {
    margin: 0 auto;
    max-width: 280px;
  }

  .straight-feature-card-wide .straight-feature-card-img-wrapper {
    max-width: 70%;
  }

  .straight-costs-type-title {
    font-size: 15px;
  }

  .straight-costs-type-sub {
    font-size: 14px;
  }

  .straight-costs-th {
    font-size: 14px;
  }

  .straight-costs-col-speed {
    font-size: 14px;
  }

  .straight-badge-sub {
    font-size: 11px;
  }

  .straight-badge-text {
    font-size: 13px;
  }

  .straight-faq-title {
    font-size: 24px;
  }

  .straight-faq-question-btn {
    padding: 18px;
    font-size: 16px;
  }

  .straight-cta-section {
    padding: 30px 0 40px;
  }

  .straight-cta-subtitle {
    font-size: 15px;
  }

  .straight-cta-disclaimer {
    font-size: 15px;
  }

  .straight-cta-section .straight-btn-primary {
    font-size: 15px;
    padding: 10px 24px;
    border-radius: 14px;
  }

  .straight-costs-header {
    margin-bottom: 20px;
  }

  .straight-costs-section {
    padding: 35px 0 40px;
  }

  .straight-faq-header {
    margin-bottom: 20px;
  }

  .straight-faq-section {
    padding: 35px 0 35px;
  }

  .straight-container {
    max-width: 100%;
  }

  .straight-hero-actions {
    gap: 12px;
    flex-wrap: nowrap;
  }


}

@media (max-width:580px) {

  .straight-features-grid-mid .straight-feature-card {
    flex-direction: column;
    gap: 24px;
  }

  .straight-faq-question-btn {
    font-size: 15px;
  }

  .straight-faq-answer p {
    font-size: 14px;
  }

  .straight-cta-subtitle {
    margin-bottom: 15px;
  }

  .straight-cta-btn {
    margin-bottom: 0px;
  }

  .straight-faq-icon-wrapper {
    width: 22px;
    height: 22px;
  }

  .straight-feature-card-img-wrapper {
    max-width: 210px;
  }

  .straight-features-grid-mid .straight-feature-card-img-wrapper {
    min-width: 205px;
  }

  .straight-costs-row-card {
    padding: 12px 15px;
  }

  .straight-badge {
    padding: 8px 22px;
    min-width: auto;
  }

  .straight-badge-text {
    font-size: 12px;
  }

  .straight-costs-table-header-row {
    padding: 0 5px 10px;
  }

  .straight-costs-col-speed {
    font-size: 13px;
  }

  .straight-costs-type-sub {
    font-size: 12px;
  }

  .straight-costs-type-title {
    font-size: 14px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Straight/straight.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yDAAoF;EACpF,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,yDAA0F;AAC5F;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,2CAA2C;EAC3C,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;;EAEE;;IAEE,qDAAqD;EACvD;;EAEA;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;EAEE;;IAEE,sDAAsD;EACxD;;EAEA;IACE,qDAAqD;EACvD;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,wCAAwC;EACxC,oBAAoB;EACpB,uBAAuB;EACvB,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,6EAA6E;AAC/E;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yDAAiF;EACjF,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,yDAAuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yFAAyF;EACzF,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,0FAA0F;EAC1F,0CAA0C;EAC1C,kCAA0B;UAA1B,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,yDAAkF;EAClF,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yDAAwF;AAC1F;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;EACF;;AAEF;;AAEA;;EAEE;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;AAEF;;;AAGA;;;EAGE;IACE,qCAAqC;IACrC,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;;AAGF;;AAEA;;EAEE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":[".straight-page-wrapper {\n  background-color: #0b0e14;\n  color: #f1f5f9;\n  overflow-x: hidden;\n  position: relative;\n  min-height: 100vh;\n}\n\n.straight-container {\n  max-width: 1480px;\n  margin: 0 auto;\n  padding: 0 20px;\n  position: relative;\n  z-index: 2;\n}\n\n.straight-text-gold {\n  color: #D1AA67;\n}\n\n/* ==========================================================================\n   2. HERO SECTION\n   ========================================================================== */\n.straight-hero-section {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 1060px;\n  text-align: center;\n  overflow: hidden;\n  background-image: url('../../../../public/images/straight_img/straight_bg_hero.jpg');\n  background-position: center top;\n  background-repeat: no-repeat;\n}\n\nbody.light_theme .straight-hero-section {\n  background-image: url('../../../../public/images/straight_img/straight_bg_hero_light.jpg');\n}\n\n.straight-hero-particles-canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.straight-hero-content {\n  position: relative;\n  z-index: 2;\n  max-width: 1220px;\n  margin: 0 auto;\n  padding-top: 230px;\n}\n\n.straight-hero-title {\n  font-size: 80px;\n  font-weight: 600;\n  line-height: 1.18;\n  color: #ffffff;\n  margin-bottom: 22px;\n}\n\nbody.light_theme .straight-hero-title {\n  color: #1f1f1f;\n}\n\n.straight-hero-subtitle {\n  font-size: 28px;\n  line-height: 1.6;\n  color: #9CA3AF;\n  max-width: 870px;\n  margin: 0 auto 36px;\n  font-weight: 400;\n}\n\n.straight-hero-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.straight-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #D1AA67;\n  color: #fff;\n  font-size: 22px;\n  font-weight: 500;\n  padding: 14px 36px;\n  min-height: 70px;\n  border-radius: 9999px;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 4px 20px rgba(230, 167, 58, 0.35);\n  transition: all 0.3s ease;\n}\n\n.straight-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 26px rgba(230, 167, 58, 0.5);\n  color: #0b0e14;\n}\n\n.straight-btn-primary i {\n  transition: transform 0.2s ease;\n}\n\n.straight-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgb(82 82 82 / 85%);\n  color: #E5E7EB;\n  font-size: 22px;\n  font-weight: 500;\n  padding: 14px 36px;\n  min-height: 70px;\n  border-radius: 9999px;\n  text-decoration: none;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  -webkit-backdrop-filter: blur(8px);\n  backdrop-filter: blur(8px);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.straight-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.25);\n  color: #ffffff;\n  transform: translateY(-2px);\n}\n\n/* ==========================================================================\n   3. FOUR STEPS SECTION\n   ========================================================================== */\n.straight-steps-section {\n  position: relative;\n  padding: 100px 0 110px;\n  background-color: #1E2025;\n}\n\nbody.light_theme .straight-steps-section {\n  background-color: #ffffff;\n}\n\nbody.light_theme .straight-steps-title {\n  color: #141414;\n}\n\nbody.light_theme .straight-step-card {\n  background: rgb(0 0 0 / 10%);\n  border: 1px solid rgb(0 0 0 / 7%);\n  box-shadow: 0px 0px 0px 6px rgb(0 0 0 / 15%);\n}\n\n.straight-steps-section-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.straight-steps-title {\n  font-size: 60px;\n  font-weight: 500;\n  color: #ffffff;\n}\n\n.straight-steps-grid-container {\n  position: relative;\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 40px 0px 24px;\n}\n\n/* Horizontal Blue Dotted Connector */\n.straight-steps-horizontal-track {\n  position: absolute;\n  top: 50%;\n  left: 40px;\n  right: 40px;\n  transform: translateY(-50%);\n  height: 2px;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.steps_afterlft.effectusdt {\n  left: -30px;\n}\n\n.steps_afterrgt.effectusdt {\n  right: -30px;\n}\n\n.effectusdt {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 250px;\n  opacity: 0.5;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.straight-golden-matrix-canvas {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.straight-steps-blue-line {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  border-top: 2px dashed #0284c7;\n  opacity: 0.85;\n}\n\n.straight-steps-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 28px;\n  position: relative;\n  z-index: 2;\n  justify-items: center;\n}\n\n.straight-step-card-wrapper {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 320px;\n  height: 450px;\n}\n\n/* Outer Orbit SVG Track matching exact Figma layout */\n.straight-step-orbit-figma-svg {\n  position: absolute;\n  top: -65px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 340px;\n  height: 580px;\n  pointer-events: none;\n  z-index: 1;\n  overflow: visible;\n}\n\n.straight-step-base-arc {\n  stroke: rgba(209, 170, 103, 0.35);\n  transition: stroke 0.3s ease;\n}\n\nbody.light_theme .straight-step-base-arc {\n  stroke: rgba(209, 170, 103, 0.5);\n}\n\n.straight-step-top-arc {\n  stroke: #D1AA67;\n  stroke-dasharray: 160 440;\n  animation: flowFigmaTopArc 5.5s linear infinite;\n}\n\n.straight-step-bottom-arc {\n  stroke: #D1AA67;\n  stroke-dasharray: 160 440;\n  animation: flowFigmaBottomArc 5.5s linear infinite;\n}\n\nbody.light_theme .straight-step-top-arc,\nbody.light_theme .straight-step-bottom-arc {\n  stroke: #D1AA67;\n}\n\n@keyframes flowFigmaTopArc {\n  0% {\n    stroke-dashoffset: 0;\n  }\n\n  100% {\n    stroke-dashoffset: -600;\n  }\n}\n\n@keyframes flowFigmaBottomArc {\n  0% {\n    stroke-dashoffset: 0;\n  }\n\n  100% {\n    stroke-dashoffset: 600;\n  }\n}\n\n.straight-step-node-bg {\n  fill: #1E2025;\n  transition: fill 0.3s ease;\n}\n\nbody.light_theme .straight-step-node-bg {\n  fill: #ffffff;\n}\n\n.straight-step-node-dot {\n  fill: #D1AA67;\n}\n\n.straight-step-node-glow {\n  transform-origin: center center;\n  animation: pulseNodeGlow 4s ease-in-out infinite;\n}\n\n@keyframes pulseNodeGlow {\n\n  0%,\n  100% {\n    filter: drop-shadow(0 0 3px rgba(209, 170, 103, 0.6));\n  }\n\n  50% {\n    filter: drop-shadow(0 0 8px rgba(209, 170, 103, 0.95));\n  }\n}\n\nbody.light_theme .straight-step-node-glow {\n  animation: pulseNodeGlowLight 4s ease-in-out infinite;\n}\n\n@keyframes pulseNodeGlowLight {\n\n  0%,\n  100% {\n    filter: drop-shadow(0 0 3px rgba(209, 170, 103, 0.45));\n  }\n\n  50% {\n    filter: drop-shadow(0 0 7px rgba(209, 170, 103, 0.8));\n  }\n}\n\n.straight-step-card {\n  position: relative;\n  z-index: 2;\n  background: rgb(255 255 255 / 10%);\n  border: 1px solid rgb(255 255 255 / 22%);\n  border-radius: 100px;\n  padding: 36px 26px 40px;\n  box-shadow: 0px 0px 0px 6px rgb(255 255 255 / 20%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  transition: all 0.35s ease;\n  min-height: 450px;\n  width: 210px;\n  backdrop-filter: blur(12px);\n}\n\n.straight-step-card:hover {\n  transform: translateY(-6px);\n  border-color: rgba(245, 184, 66, 0.3);\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.45), 0 0 24px rgba(245, 184, 66, 0.1);\n}\n\n.straight-step-icon-box {\n  width: 122px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  transition: all 0.3s ease;\n}\n\n.straight-step-card:hover .straight-step-icon-box {\n  background: rgba(245, 184, 66, 0.12);\n  border-color: rgba(245, 184, 66, 0.4);\n  transform: scale(1.05);\n}\n\n.straight-step-icon {\n  width: 100%;\n  object-fit: contain;\n}\n\n.straight-step-card-title {\n  font-size: 24px;\n  font-weight: 500;\n  color: #ffffff;\n  margin-bottom: 10px;\n  line-height: 1.35;\n  /* min-height: 44px; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .straight-step-card-title {\n  color: #212121;\n}\n\n.straight-step-card-desc {\n  font-size: 13px;\n  color: #94A3B8;\n  line-height: 1.55;\n  margin: 0;\n}\n\nbody.light_theme .straight-step-card-desc {\n  color: #5f5f5f;\n}\n\nbody.light_theme .straight-features-section {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .straight-features-title {\n  color: #202020;\n}\n\nbody.light_theme .straight-feature-card {\n  background: rgb(39 40 46 / 6%);\n  border: 1px solid rgb(0 0 0 / 6%);\n}\n\nbody.light_theme .straight-feature-card-title {\n  color: #232323;\n}\n\nbody.light_theme .straight-feature-card-desc {\n  color: #393939;\n}\n\nbody.light_theme .straight-feature-card-img-wrapper {\n  opacity: 0.4;\n}\n\n/* Connecting arrows / curves between steps */\n.straight-steps-connectors {\n  position: absolute;\n  top: 70px;\n  left: 0;\n  width: 100%;\n  height: 200px;\n  pointer-events: none;\n  z-index: 1;\n}\n\n/* ==========================================================================\n   4. THE SIMPLE WAY SECTION (FEATURES GRID)\n   ========================================================================== */\n.straight-features-section {\n  position: relative;\n  padding: 100px 0 110px;\n  background-color: #171A20;\n  overflow: hidden;\n}\n\n.straight-features-header {\n  text-align: center;\n  margin-bottom: 60px;\n  position: relative;\n  z-index: 2;\n}\n\n.straight-features-title {\n  font-size: 60px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.25;\n}\n\n.straight-features-grid-top {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  margin-bottom: 24px;\n  position: relative;\n  z-index: 2;\n}\n\n.straight-features-grid-mid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n  margin-bottom: 24px;\n  position: relative;\n  z-index: 2;\n}\n\n.straight-features-grid-bottom {\n  display: grid;\n  grid-template-columns: 1fr;\n  position: relative;\n  z-index: 2;\n}\n\n.straight-feature-card {\n  background: #27282E;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 24px;\n  padding: 32px 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.35s ease;\n}\n\n.straight-feature-card:hover {\n  transform: translateY(-4px);\n  border-color: rgba(245, 184, 66, 0.25);\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.4);\n}\n\n.straight-feature-card-content {\n  position: relative;\n  z-index: 2;\n  margin-bottom: 0px;\n}\n\n.straight-feature-card-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ededed;\n  margin-bottom: 12px;\n  line-height: 1.3;\n}\n\n.straight-feature-card-desc {\n  font-size: 16px;\n  color: #AEAEAE;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.straight-feature-card-img-wrapper {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  filter: brightness(0.5);\n  opacity: 0.6;\n}\n\n.straight-features-grid-mid .straight-feature-card {\n  flex-direction: row;\n  gap: 48px;\n}\n\n.straight-features-grid-mid .straight-feature-card-img-wrapper {\n  width: 100%;\n  min-width: 255px;\n}\n\n.straight-feature-card-img {\n  max-width: 100%;\n  object-fit: contain;\n  transition: transform 0.4s ease;\n}\n\n.straight-feature-card:hover .straight-feature-card-img {\n  transform: scale(1.04);\n}\n\n/* Wide bottom card layout */\n.straight-feature-card-wide {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 36px 40px;\n  gap: 40px;\n}\n\n.straight-feature-card-wide .straight-feature-card-content {\n  max-width: 780px;\n  margin-bottom: 0;\n}\n\n.straight-feature-card-wide .straight-feature-card-img-wrapper {\n  max-width: 330px;\n  margin-top: 0;\n  margin-right: 100px;\n  min-height: auto;\n}\n\n.straight-feature-card-wide .straight-feature-card-img {\n  max-height: 100%;\n}\n\n.straight-feature-card:hover .straight-feature-card-img-wrapper {\n  filter: brightness(1);\n  opacity: 1;\n}\n\n/* ==========================================================================\n   5. COSTS AND DURATION SECTION (TABLE)\n   ========================================================================== */\n.straight-costs-section {\n  position: relative;\n  padding: 100px 0 110px;\n  background-image: url('../../../../public/images/straight_img/convert_howbg.jpg');\n  background-position: center top;\n  background-repeat: no-repeat;\n}\n\nbody.light_theme .straight-costs-section {\n  background-image: url('../../../../public/images/straight_img/convert_howbg_light.jpg');\n}\n\n.straight-costs-header {\n  text-align: center;\n  margin-bottom: 50px;\n}\n\n.straight-costs-title {\n  font-size: 60px;\n  font-weight: 500;\n  color: #ffffff;\n  line-height: 1.25;\n}\n\nbody.light_theme .straight-costs-title {\n  color: #202020;\n}\n\n.straight-costs-table-card {\n  max-width: 100%;\n  margin: 0 auto;\n  background: linear-gradient(180deg, rgba(50, 41, 26, 0.9) 0%, rgba(23, 26, 32, 0.95) 78%);\n  border: 1px solid rgba(209, 170, 103, 0.2);\n  border-radius: 32px;\n  padding: 36px 40px 42px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.4);\n}\n\nbody.light_theme .straight-costs-table-card {\n  background: linear-gradient(180deg, rgba(50, 41, 26, 0.05) 0%, rgba(23, 26, 32, 0.10) 78%);\n  border: 1px solid rgba(209, 170, 103, 0.2);\n  backdrop-filter: blur(8px);\n  box-shadow: 0 24px 60px rgb(0 0 0 / 15%);\n}\n\n.straight-costs-table-header-row {\n  display: grid;\n  grid-template-columns: 2.2fr 1.6fr 2.4fr;\n  padding: 0 32px 18px;\n  align-items: center;\n}\n\n.straight-costs-th {\n  font-size: 20px;\n  font-weight: 500;\n  color: #CBD5E1;\n}\n\nbody.light_theme .straight-costs-th {\n  color: #242424;\n}\n\nbody.light_theme .straight-costs-row-card {\n  background: rgb(0 0 0 / 5%);\n  border: 1px solid rgb(0 0 0 / 6%);\n}\n\nbody.light_theme .straight-costs-type-title {\n  color: #000;\n}\n\nbody.light_theme .straight-costs-type-sub {\n  color: #232323;\n}\n\nbody.light_theme .straight-costs-speed-main {\n  color: #232323;\n}\n\nbody.light_theme .straight-costs-speed-sub {\n  color: #4e4e4e;\n}\n\nbody.light_theme .straight-badge-sub {\n  color: #2f2f2f;\n}\n\n.straight-costs-th-type {\n  text-align: left;\n}\n\n.straight-costs-th-cost {\n  text-align: center;\n}\n\n.straight-costs-th-speed {\n  text-align: left;\n}\n\n.straight-costs-rows-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.straight-costs-row-card {\n  display: grid;\n  grid-template-columns: 2.2fr 1.6fr 2.4fr;\n  align-items: center;\n  background: rgb(255 255 255 / 10%);\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 20px;\n  padding: 18px 36px;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.straight-costs-row-card:hover {\n  background: #2a2e36;\n  border-color: rgba(209, 170, 103, 0.22);\n  transform: translateY(-2px);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);\n}\n\n.straight-costs-col-type {\n  display: flex;\n  flex-direction: column;\n}\n\n.straight-costs-type-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1.3;\n}\n\n.straight-costs-type-sub {\n  font-size: 16px;\n  color: #94A3B8;\n  margin-top: 4px;\n}\n\n.straight-costs-col-cost {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.straight-costs-col-speed {\n  font-size: 18px;\n  line-height: 1.45;\n  font-weight: 300;\n}\n\n.straight-costs-speed-main {\n  color: #e2e8f0;\n  font-weight: 500;\n}\n\n.straight-costs-speed-sub {\n  color: #7b8494;\n  font-weight: 400;\n}\n\n/* Badges */\n.straight-badge {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 13px 48px;\n  border-radius: 9999px;\n  text-align: center;\n  min-width: 170px;\n  transition: all 0.25s ease;\n}\n\n.straight-badge-text {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.straight-badge-sub {\n  font-size: 14px;\n  color: #94A3B8;\n  margin-top: 2px;\n  line-height: 1.2;\n}\n\n.straight-badge-green {\n  background: rgb(0 77 64 / 25%);\n  color: #00E5B3;\n  border: 1.5px solid rgb(0 229 179 / 30%);\n}\n\n.straight-badge-gold {\n  background: rgb(69 39 2 / 25%);\n  color: #FBBF24;\n  border: 1.5px solid rgb(245 158 11 / 40%);\n}\n\n.straight-badge-blue {\n  background: rgb(12 53 77 / 30%);\n  color: #38BDF8;\n  border: 1.5px solid rgb(2 132 199 / 40%);\n}\n\n.straight-badge-purple {\n  background: rgb(54 19 74 / 30%);\n  color: #D8B4FE;\n  border: 1.5px solid rgb(168 85 247 / 40%);\n  padding: 9px 26px;\n}\n\n/* ==========================================================================\n   6. FAQ SECTION (ACCORDION)\n   ========================================================================== */\n.straight-faq-section {\n  position: relative;\n  padding: 110px 0 50px;\n  background-color: #171A20;\n  margin-top: -2px;\n}\n\nbody.light_theme .straight-faq-section {\n  background-color: #ffffff;\n}\n\nbody.light_theme .straight-faq-title {\n  color: #202020;\n}\n\nbody.light_theme .straight-faq-item {\n  background: rgb(0 0 0 / 4%);\n}\n\nbody.light_theme .straight-faq-question-btn {\n  color: #212121;\n}\n\nbody.light_theme .straight-faq-icon-wrapper {\n  border: 1px solid rgb(0 0 0);\n}\n\nbody.light_theme .straight-faq-answer {\n  color: #535353;\n  border-top: 1px solid rgb(0 0 0 / 5%);\n}\n\nbody.light_theme .straight-cta-section {\n  background-color: #ffffff;\n}\n\n.straight-faq-header {\n  margin-bottom: 36px;\n}\n\n.straight-faq-title {\n  font-size: 52px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.straight-faq-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin: 0 auto;\n}\n\n.straight-faq-item {\n  background: rgb(255 255 255 / 4%);\n  border-radius: 18px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.straight-faq-item:hover {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n/* .straight-faq-item.active {\n  border-color: rgba(245, 184, 66, 0.3);\n  background: rgba(22, 27, 38, 0.9);\n} */\n\n.straight-faq-question-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px;\n  background: none;\n  border: none;\n  color: #ffffff;\n  font-size: 22px;\n  font-weight: 400;\n  text-align: left;\n  cursor: pointer;\n  gap: 16px;\n  transition: color 0.2s ease;\n}\n\n.straight-faq-icon-wrapper {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.straight-faq-item.active .straight-faq-icon-wrapper {\n  background: rgb(209 170 103 / 20%);\n  border-color: #d1aa67;\n  color: #d1aa67;\n  transform: rotate(45deg);\n}\n\n.straight-faq-answer {\n  padding: 0 24px 22px;\n  color: #94a3b8;\n  border-top: 1px solid rgba(255, 255, 255, 0.04);\n  padding-top: 16px;\n}\n\n.straight-faq-answer p {\n  font-size: 16px;\n  line-height: 1.65;\n}\n\n/* ==========================================================================\n   7. CTA BANNER SECTION\n   ========================================================================== */\n.straight-cta-section {\n  position: relative;\n  padding: 50px 0 80px;\n  background-color: #171A20;\n}\n\n.straight-cta-banner-card {\n  max-width: 100%;\n  margin: 0 auto;\n  position: relative;\n  border: 1px solid rgb(119 119 119 / 25%);\n  background-image: url('../../../../public/images/straight_img/straight-ctabg.jpg');\n  background-position: center top;\n  background-repeat: no-repeat;\n  border-radius: 22px;\n  padding: 56px 36px 48px;\n  text-align: center;\n  overflow: hidden;\n}\n\nbody.light_theme .straight-cta-banner-card {\n  background-image: url('../../../../public/images/straight_img/straight-ctabg_light.jpg');\n}\n\nbody.light_theme .straight-cta-title {\n  color: #171717;\n}\n\nbody.light_theme .straight-cta-subtitle {\n  color: #424242;\n}\n\nbody.light_theme .straight-cta-disclaimer {\n  color: #434343;\n}\n\n.straight-cta-title {\n  font-size: 60px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 14px;\n}\n\n.straight-cta-subtitle {\n  font-size: 24px;\n  color: #9CA3AF;\n  margin: 0px auto 30px;\n  max-width: 800px;\n  line-height: 1.5;\n}\n\n.straight-cta-section .straight-btn-primary {\n  font-size: 21px;\n  font-weight: 500;\n  padding: 17px 36px;\n  width: 370px;\n  color: #000;\n  max-width: 100%;\n  border-radius: 22px;\n  border: 4px solid rgb(255 255 255 / 10%);\n  box-shadow: none;\n}\n\n.straight-cta-btn {\n  margin-bottom: 24px;\n}\n\n.straight-cta-disclaimer {\n  font-size: 24px;\n  color: #9CA3AF;\n  padding-top: 20px;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* ==========================================================================\n   8. RESPONSIVE MEDIA QUERIES\n   ========================================================================== */\n\n@media (max-width: 1440px) {\n\n  .straight-hero-title {\n    font-size: 60px;\n  }\n\n  .straight-hero-subtitle {\n    font-size: 24px;\n  }\n\n  .straight-steps-title {\n    font-size: 48px;\n  }\n\n  .straight-features-title {\n    font-size: 48px;\n  }\n\n  .straight-costs-title {\n    font-size: 48px;\n  }\n\n  .straight-cta-title {\n    font-size: 48px\n  }\n\n}\n\n@media (max-width: 1376px) {\n\n  .straight-hero-section {\n    min-height: 650px;\n    background-size: cover;\n  }\n\n  .straight-hero-content {\n    padding-top: 50px;\n  }\n\n  .straight-hero-title {\n    font-size: 48px;\n  }\n\n  .straight-hero-subtitle {\n    font-size: 20px;\n  }\n\n  .straight-btn-secondary {\n    font-size: 16px;\n    padding: 11px 36px;\n    min-height: 56px;\n  }\n\n  .straight-btn-primary {\n    font-size: 16px;\n    padding: 11px 36px;\n    min-height: 56px;\n  }\n\n  .straight-container {\n    max-width: 95%;\n  }\n\n  .straight-steps-title {\n    font-size: 38px;\n  }\n\n  .straight-step-card-title {\n    font-size: 20px;\n  }\n\n  .straight-features-title {\n    font-size: 38px;\n  }\n\n  .straight-costs-title {\n    font-size: 38px;\n  }\n\n  .straight-faq-title {\n    font-size: 42px;\n  }\n\n  .straight-cta-title {\n    font-size: 38px\n  }\n\n  .straight-cta-subtitle {\n    font-size: 18px;\n  }\n\n  .straight-cta-disclaimer {\n    font-size: 18px;\n  }\n\n  .straight-cta-section .straight-btn-primary {\n    font-size: 18px;\n    padding: 12px 36px;\n  }\n\n}\n\n\n@media (max-width: 1200px) {\n\n\n  .straight-steps-grid {\n    grid-template-columns: repeat(2, 1fr);\n    row-gap: 112px;\n  }\n\n  .straight-features-grid-top {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .straight-features-grid-mid {\n    grid-template-columns: 1fr;\n  }\n\n  .straight-feature-card-wide {\n    flex-direction: column;\n    text-align: left;\n    gap: 24px;\n  }\n\n  .straight-feature-card-wide .straight-feature-card-img-wrapper {\n    max-width: 100%;\n  }\n}\n\n@media (max-width:991px) {\n\n  .straight-hero-section {\n    min-height: 400px;\n  }\n\n  .straight-steps-section {\n    padding: 40px 0 50px;\n  }\n\n  .straight-features-section {\n    padding: 40px 0 50px;\n  }\n\n  .straight-features-header {\n    margin-bottom: 30px;\n  }\n\n  .straight-costs-section {\n    padding: 40px 0 50px;\n  }\n\n  .straight-badge {\n    padding: 11px 32px;\n    min-width: 100px;\n  }\n\n  .straight-badge-text {\n    font-size: 15px;\n  }\n\n  .straight-costs-col-speed {\n    font-size: 15px;\n  }\n\n  .straight-costs-row-card {\n    padding: 16px 26px;\n  }\n\n  .straight-faq-section {\n    padding: 40px 0 50px;\n  }\n\n  .straight-faq-title {\n    font-size: 32px;\n  }\n\n  .straight-faq-question-btn {\n    padding: 20px;\n    font-size: 18px;\n  }\n\n  .straight-hero-title {\n    font-size: 34px;\n  }\n\n  .straight-steps-title,\n  .straight-features-title,\n  .straight-costs-title,\n  .straight-cta-title {\n    font-size: 28px;\n  }\n\n  .straight-steps-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .straight-features-grid-top {\n    grid-template-columns: 1fr;\n  }\n\n  .straight-costs-table-card {\n    padding: 16px;\n    overflow-x: auto;\n  }\n\n  .straight-costs-table thead th,\n  .straight-costs-table tbody td {\n    padding: 14px 10px;\n  }\n\n  .straight-cta-banner-card {\n    padding: 36px 20px 32px;\n  }\n\n  .straight-costs-row-card {\n    gap: 7px;\n  }\n\n  .straight-hero-subtitle {\n    font-size: 18px;\n  }\n}\n\n@media (max-width:767px) {\n\n  .straight-hero-title {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n\n  .straight-hero-subtitle {\n    font-size: 15px;\n    margin: 0 auto 18px;\n  }\n\n  .straight-btn-secondary {\n    font-size: 13px;\n    padding: 8px 20px;\n    min-height: 38px;\n  }\n\n  .straight-btn-primary {\n    font-size: 13px;\n    padding: 8px 20px;\n    min-height: 38px;\n  }\n\n  .straight-hero-content {\n    padding-top: 0px;\n  }\n\n  .straight-hero-section {\n    min-height: 100%;\n    padding: 40px 0px;\n  }\n\n  .straight-steps-title,\n  .straight-features-title,\n  .straight-costs-title,\n  .straight-cta-title {\n    font-size: 22px;\n  }\n\n  .effectusdt {\n    display: none;\n  }\n\n  .straight-steps-section-header {\n    margin-bottom: 28px;\n  }\n\n  .straight-steps-section {\n    padding: 35px 0 40px;\n  }\n\n  .straight-step-icon-box {\n    width: 70px;\n  }\n\n  .straight-step-card-title {\n    font-size: 18px;\n  }\n\n  .straight-features-section {\n    padding: 35px 0 40px;\n  }\n\n  .straight-feature-card {\n    padding: 24px;\n  }\n\n  .straight-features-header {\n    margin-bottom: 20px;\n  }\n\n  .straight-feature-card-title {\n    font-size: 18px;\n  }\n\n  .straight-feature-card-desc {\n    font-size: 14px;\n  }\n\n  .straight-feature-card-img-wrapper {\n    margin: 0 auto;\n    max-width: 280px;\n  }\n\n  .straight-feature-card-wide .straight-feature-card-img-wrapper {\n    max-width: 70%;\n  }\n\n  .straight-costs-type-title {\n    font-size: 15px;\n  }\n\n  .straight-costs-type-sub {\n    font-size: 14px;\n  }\n\n  .straight-costs-th {\n    font-size: 14px;\n  }\n\n  .straight-costs-col-speed {\n    font-size: 14px;\n  }\n\n  .straight-badge-sub {\n    font-size: 11px;\n  }\n\n  .straight-badge-text {\n    font-size: 13px;\n  }\n\n  .straight-faq-title {\n    font-size: 24px;\n  }\n\n  .straight-faq-question-btn {\n    padding: 18px;\n    font-size: 16px;\n  }\n\n  .straight-cta-section {\n    padding: 30px 0 40px;\n  }\n\n  .straight-cta-subtitle {\n    font-size: 15px;\n  }\n\n  .straight-cta-disclaimer {\n    font-size: 15px;\n  }\n\n  .straight-cta-section .straight-btn-primary {\n    font-size: 15px;\n    padding: 10px 24px;\n    border-radius: 14px;\n  }\n\n  .straight-costs-header {\n    margin-bottom: 20px;\n  }\n\n  .straight-costs-section {\n    padding: 35px 0 40px;\n  }\n\n  .straight-faq-header {\n    margin-bottom: 20px;\n  }\n\n  .straight-faq-section {\n    padding: 35px 0 35px;\n  }\n\n  .straight-container {\n    max-width: 100%;\n  }\n\n  .straight-hero-actions {\n    gap: 12px;\n    flex-wrap: nowrap;\n  }\n\n\n}\n\n@media (max-width:580px) {\n\n  .straight-features-grid-mid .straight-feature-card {\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  .straight-faq-question-btn {\n    font-size: 15px;\n  }\n\n  .straight-faq-answer p {\n    font-size: 14px;\n  }\n\n  .straight-cta-subtitle {\n    margin-bottom: 15px;\n  }\n\n  .straight-cta-btn {\n    margin-bottom: 0px;\n  }\n\n  .straight-faq-icon-wrapper {\n    width: 22px;\n    height: 22px;\n  }\n\n  .straight-feature-card-img-wrapper {\n    max-width: 210px;\n  }\n\n  .straight-features-grid-mid .straight-feature-card-img-wrapper {\n    min-width: 205px;\n  }\n\n  .straight-costs-row-card {\n    padding: 12px 15px;\n  }\n\n  .straight-badge {\n    padding: 8px 22px;\n    min-width: auto;\n  }\n\n  .straight-badge-text {\n    font-size: 12px;\n  }\n\n  .straight-costs-table-header-row {\n    padding: 0 5px 10px;\n  }\n\n  .straight-costs-col-speed {\n    font-size: 13px;\n  }\n\n  .straight-costs-type-sub {\n    font-size: 12px;\n  }\n\n  .straight-costs-type-title {\n    font-size: 14px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
